import { useHalloween } from "@/lib/halloween";

const BATS = [[8, 0], [34, 4.5], [62, 9], [86, 2.5], [48, 13]];
const GHOSTS = [[6, 30, 0], [91, 55, 3], [12, 78, 6]];

const Web = ({ flip }) => (
  <svg viewBox="0 0 120 120" className={`hw-web ${flip ? "hw-web-r" : ""}`} aria-hidden>
    {[0, 22, 45, 68, 90].map((a) => <line key={a} x1="0" y1="0" x2={120 * Math.cos((a * Math.PI) / 180)} y2={120 * Math.sin((a * Math.PI) / 180)} />)}
    {[30, 55, 80, 105].map((r) => <path key={r} d={`M ${r} 0 Q ${r * 0.8} ${r * 0.32} ${r * 0.71} ${r * 0.71} Q ${r * 0.32} ${r * 0.8} 0 ${r}`} />)}
  </svg>
);

export function HalloweenLayer() {
  const on = useHalloween();
  if (!on) return null;
  return (
    <div className="hw-layer" aria-hidden data-testid="halloween-layer">
      <Web />
      <Web flip />
      <span className="hw-spider"><span className="hw-thread" />🕷️</span>
      {BATS.map(([top, d], i) => <span key={i} className="hw-bat" style={{ top: `${top}%`, animationDelay: `${d}s`, animationDuration: `${14 + i * 2}s` }}>🦇</span>)}
      {GHOSTS.map(([left, top, d], i) => <span key={i} className="hw-ghost" style={{ left: `${left}%`, top: `${top}%`, animationDelay: `${d}s` }}>👻</span>)}
      <span className="hw-pumpkin hw-pumpkin-l">🎃</span>
      <span className="hw-pumpkin hw-pumpkin-r">🎃</span>
    </div>
  );
}

export const HalloweenBadge = ({ className = "" }) => (useHalloween() ? (
  <span className={`hw-badge ${className}`} data-testid="halloween-badge">🎃 Happy Halloween – nur bis morgen 6 Uhr 👻</span>
) : null);
